(() => {
  if (window.__simplyPencilsGalleryNavLoaded) return;
  window.__simplyPencilsGalleryNavLoaded = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.sp-gallery-nav');
    if (!button) return;

    const gallery = button.closest('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;


    const thumbnailItems = Array.from(
      gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]')
    ).filter((item) => {
      // Exclude photographs hidden by our color gallery.
      if (getComputedStyle(item).display === 'none') {
        return false;
      }

      // Preserve the original variant-thumbnail behavior.
      if (!item.classList.contains('thumbnail-list_item--variant')) {
        return true;
      }

      return item.classList.contains('sp-selected-variant-thumb');
    });

    if (thumbnailItems.length < 2) return;

    const activeMedia = gallery.querySelector('[id^="GalleryViewer"] [data-media-id].is-active');
    const currentId = activeMedia?.dataset.mediaId;
    let currentIndex = thumbnailItems.findIndex((item) => item.dataset.target === currentId);
    if (currentIndex < 0) currentIndex = 0;

    const direction = button.classList.contains('sp-gallery-nav--next') ? 1 : -1;
    const nextIndex = (currentIndex + direction + thumbnailItems.length) % thumbnailItems.length;
    const targetId = thumbnailItems[nextIndex]?.dataset.target;

    if (targetId) {
      gallery.setActiveMedia(targetId, false);
      button.focus({ preventScroll: true });
    }
  });
})();